import React from "react";
import {
  Modal,
  View,
  StyleSheet,
  TouchableOpacity,
  type ModalProps,
  type StyleProp,
  type ViewStyle,
} from "react-native";
import CustomText from "../CustomText/CustomText";
import { X } from "@phosphor-icons/react/dist/csr/X";
import { shadowStyles } from "../../../../styles/shadow";
import { getModalAnimationType } from "../../../../utils/getModalAnimationType";

interface CustomAdminModalProps extends Omit<ModalProps, "visible" | "onRequestClose"> {
  visible: boolean;
  onRequestClose: () => void;
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  title?: string;
  onShow?: ModalProps["onShow"];
  ariaLabel?: string;
}

const CustomAdminModal: React.FC<CustomAdminModalProps> = ({
  visible,
  onRequestClose,
  children,
  style,
  title = "",
  onShow = undefined,
  ariaLabel = "",
  animationType,
  ...props
}) => {
  const resolvedAriaLabel = ariaLabel || title;

  return (
    <Modal
      role="dialog"
      aria-labelledby={resolvedAriaLabel}
      id="custom-admin-modal"
      animationType={getModalAnimationType(animationType ?? "fade")}
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}
      onShow={onShow}
      {...props}>
      <View style={styles.centeredView}>
        <View style={[styles.modalView, shadowStyles.modal, style]}>
          <View style={styles.header}>
            <CustomText
              role="heading"
              aria-level={1}
              text={title}
              style={styles.titleText}
              useTranslationText={false}
            />
            <TouchableOpacity style={styles.closeButton} onPress={onRequestClose} aria-label="Close modal">
              <X size={16} weight="bold" color="#667085" />
            </TouchableOpacity>
          </View>
          <View style={styles.content}>{children}</View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalView: {
    borderRadius: 16,
    backgroundColor: "#ffffff",
    overflow: "hidden",
    width: "90%",
    maxWidth: 600,
    maxHeight: "90%",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 24,
    backgroundColor: "#F2F4F7",
  },
  titleText: {
    fontSize: 20,
    fontWeight: "600",
    color: "#101828",
  },
  closeButton: {
    padding: 4,
  },
  content: {
    backgroundColor: "#ffffff",
    flex: 1,
  },
});

export default CustomAdminModal;
